import { IService, TaskOptions } from '@alberta/konexi-shared';
import { ignore } from '@common/tracking/tracker';
import { BaseViewModel } from '@common/viewmodel/base-view-model';

export class ServiceViewModel extends BaseViewModel implements IService {
  taskOptions: TaskOptions;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;
  name: string;
  description: string;
  additionalDescription: string;
  isAddOn?: boolean;
  isTimeSpecific?: boolean;
  localization?: boolean;
  specializedServiceProviderBranchIds?: string[];

  @ignore()
  checked: boolean;

  /** An empty or missing list means the service is available for every branch. */
  public isAvailableForBranch(branchId?: string): boolean {
    return (
      !branchId ||
      !this.specializedServiceProviderBranchIds?.length ||
      this.specializedServiceProviderBranchIds.includes(branchId)
    );
  }
}
